import { Navbar } from "@components/navbar";
import { AWSUser } from "@archetypes/auth";
import { FC } from "react";
import { Outlet, useNavigate, useOutletContext } from "react-router-dom";

const AppsAreaLayout: FC = () => {
  const user = useOutletContext<AWSUser>();
  const navigate = useNavigate();

  return (
    <main className="main-container">
      <div className="content-area w-100">
        <header className="header-area">
          <Navbar basePath="/apps" user={user} onNavbarButtonClick={() => navigate("/apps")} />
        </header>

        <div className="flex justify-center">
          <div className="app-content-area w-100">
            <Outlet context={user} />
          </div>
        </div>
      </div>
    </main>
  );
};

export default AppsAreaLayout;
